
    import './styles.scoped.css';
    export default {
  "root": "awsui_root_swimc_12lxg_99",
  "anchor-list": "awsui_anchor-list_swimc_12lxg_134",
  "anchor-item": "awsui_anchor-item_swimc_12lxg_157",
  "anchor-item--active": "awsui_anchor-item--active_swimc_12lxg_177",
  "anchor-link": "awsui_anchor-link_swimc_12lxg_194",
  "anchor-link--active": "awsui_anchor-link--active_swimc_12lxg_236",
  "anchor-link-text": "awsui_anchor-link-text_swimc_12lxg_243",
  "anchor-link-info": "awsui_anchor-link-info_swimc_12lxg_247"
};
  